import Vue from "vue";
import Router from "vue-router";

const _import = file => () => import("pages/" + file + "/" + file + ".vue");
Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Home",
    component: _import("Home")
  },
  {
    path: "/detail/:pk",
    name: "detail",
    component: _import("Detail")
  },
  {
    path: "/detail/:pk/:address/:type",
    name: "detailtype",
    component: _import("Detail")
  },
  {
    path: "/detail/:pk/:address",
    name: "detailwithouttype",
    component: _import("Detail")
  },
  {
    path: "/stake",
    name: "stake",
    component: _import("Stake")
  },
  {
    path: "/calculator/:type",
    name: "calculator",
    component: _import("Calculator")
  },
  {
    path: "/calculator",
    name: "calculatoronly",
    component: _import("Calculator")
  },
  {
    path: "/voting-policy/:lang",
    component: _import("Vote")
  },
  {
    path: "/voting-policy",
    name: "voting",
    component: _import("Vote")
  },
];

const router = new Router({
  mode: "history",
  routes: routes,
/*   scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  } */
});

export default router;
